import './_mini-cart.scss';
import component from './mini-cart';

export default component;
